import React from 'react';
import PropTypes from 'prop-types';
import Slick from 'react-slick';

import IconButton from '@adsk/bim360-matrix-react-icon-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import navigationArrow from '@adsk/bim360-matrix-react-assets/navigation-arrow.svg';

import './_ThumbnailStrip.scss';
export default class ThumbnailStrip extends React.Component {
  _renderArrow(isPrevious) {
    const Arrow = ({ onClick, className, currentSlide, slideCount, isPrevious }) => (
      <IconButton
        className={`${className} ThumbnailStrip__arrow-${isPrevious ? 'previous' : 'next'}`}
        onClick={onClick}
      >
        <SvgIcon width="16px" height="16px" transform={isPrevious ? 'rotate(180 8 8)' : null}>
          {navigationArrow}
        </SvgIcon>
      </IconButton>
    );

    return <Arrow isPrevious={isPrevious} />;
  }

  render() {
    const { children, className, afterChange, beforeChange, ...slickProps } = this.props;
    const slickSettings = {
      autoplay: false,
      dots: false,
      draggable: false,
      nextArrow: this._renderArrow(false),
      prevArrow: this._renderArrow(true),
      afterChange: selectedItem => {
        const canGoNext =
          this.props.infinite ||
          (children.length > this.props.slidesToShow &&
            selectedItem < children.length - this.props.slidesToShow);
        const canGoBack =
          this.props.infinite || (selectedItem !== 0 && children.length > this.props.slidesToShow);

        afterChange(selectedItem, canGoNext, canGoBack);
      },
      beforeChange: (currentItem, selectedItem) => {
        const canGoNext =
          this.props.infinite ||
          (children.length > this.props.slidesToShow &&
            selectedItem < children.length - this.props.slidesToShow);
        const canGoBack =
          this.props.infinite || (selectedItem !== 0 && children.length > this.props.slidesToShow);

        beforeChange(selectedItem, canGoNext, canGoBack);
      },
      ...slickProps
    };

    return (
      <Slick
        ref={s => (this.slick = s)}
        className={`ThumbnailStrip ${className}`}
        {...slickSettings}
      >
        {children.map(child => {
          return React.cloneElement(child, {
            className: `${child.props.className || ''} ThumbnailStrip__thumbnail`
          });
        })}
      </Slick>
    );
  }
}

ThumbnailStrip.defaultProps = {
  infinite: false,
  lazyLoad: false,
  slidesToScroll: 1,
  swipeToSlide: false,
  variableWidth: false,
  focusOnSelect: false,
  afterChange: () => {},
  beforeChange: () => {},
  className: ''
};

ThumbnailStrip.propTypes = {
  /**
   * An Array of nodes to be rendered as the elements in the thumbnail strip, these don't have to be images.
   */
  children: PropTypes.arrayOf(PropTypes.node),
  /**
   * An extra class to be added on the ThumbnailStrip component.
   */
  className: PropTypes.string,
  /**
   * Whether or not the thumbnail strip should be infinite or not.
   */
  infinite: PropTypes.bool,
  /**
   * Whether or not the children in the thumbnail strip should be loaded only when reached.
   */
  lazyLoad: PropTypes.bool,
  /**
   * Number of children to show at any given time.
   */
  slidesToShow: PropTypes.number,
  /**
   * Number of children to scroll when clicking on the navigation arrows
   */
  slidesToScroll: PropTypes.number,
  /**
   * The index of the first child that should be rendered
   */
  initialSlide: PropTypes.number,
  /**
   * Whether or not we should be able to swipe in order to scroll through the thumbnails
   */
  swipeToSlide: PropTypes.bool,
  /**
   * Whether or not the width of each thumbnail is different
   */
  variableWidth: PropTypes.bool,
  /**
   * Whether or not we want to focus on the selected child
   */
  focusOnSelect: PropTypes.bool,
  /**
   * Whether or not we want to make the thumbnail show the current child in the middle of the thumbnail strip
   */
  centerMode: PropTypes.bool,
  /**
   * A function that's called after a change to the current child has occurred
   * function(selectedItem, canGoNext, canGoBack)
   */
  afterChange: PropTypes.func,
  /**
   * A function that's called before a change to the current child has occurred
   * function(selectedItem, canGoNext, canGoBack)
   */
  beforeChange: PropTypes.func
};
